import React from 'react';
import VideoList from './VideoList.js';

const VideoSearch = ({playlist, videos, filter, onVideoAdd, onFilterChange, onVideoUpdate}) => (
  <div className="video-search">
    <input 
      className="input" value={filter} placeholder="Video name" 
      onKeyDown={(event) => {
        if(event.keyCode === 13) {
          onVideoUpdate(filter);
        }
      }}
      onChange={(event) => { 
        onFilterChange(event.target.value); 
      }}
    />
    <button className="button is-info" onClick={() => { onVideoUpdate(filter) }}>Search</button>
    <VideoList playlist={playlist} videos={videos} onVideoAdd={onVideoAdd}/>
  </div>
)

export default VideoSearch



// WEBPACK FOOTER //
// ./src/components/VideoSearch.js